module.exports = __webpack_public_path__ + "img/comunicazioni.7d395a69.jpg";